<template>
  <div class="map-container">
    <div class="search-container">
      <input
        id="search-input"
        type="text"
        placeholder="Search location"
        class="search-input"
      />
    </div>
    <div id="map" class="map-area"></div>
  </div>
</template>


<script>
export default {
  name: "GoogleMap",
  props: {
    defaultCenter: {
      type: Object,
      default: () => ({ lat: 20.5937, lng: 78.9629 }) // India default
    }
  },
  data() {
    return {
      map: null,
      marker: null,
      searchBox: null
    };
  },
  mounted() {
    this.initMap();
  },
  methods: {
    initMap() {
      this.map = new google.maps.Map(document.getElementById("map"), {
        center: this.defaultCenter,
        zoom: 6
      });

      this.marker = new google.maps.Marker({
        map: this.map,
        position: this.defaultCenter,
        draggable: true
      });

      this.emitLocation(this.defaultCenter); // Initial emit

      this.marker.addListener("dragend", (event) => {
        const position = {
          lat: event.latLng.lat(),
          lng: event.latLng.lng()
        };
        this.emitLocation(position);
      });

      this.map.addListener("click", (event) => {
        const position = {
          lat: event.latLng.lat(),
          lng: event.latLng.lng()
        };
        this.marker.setPosition(position);
        this.emitLocation(position);
      });

      const input = document.getElementById("search-input");
      this.searchBox = new google.maps.places.SearchBox(input);

      this.searchBox.addListener("places_changed", () => {
        const places = this.searchBox.getPlaces();
        if (places.length === 0) return;

        const place = places[0];
        const position = {
          lat: place.geometry.location.lat(),
          lng: place.geometry.location.lng()
        };

        this.map.setCenter(position);
        this.marker.setPosition(position);
        this.emitLocation(position);
      });
    },
    emitLocation(location) {
      this.$emit("location-changed", location);
    }
  }
};
</script>

<style scoped>
.map-container {
  display: flex;
  flex-direction: column;
  width: 100%;
  max-width: 100%;
}

.search-container {
  display: flex;
  justify-content: center;
  padding: 10px;
  background-color: white;
  z-index: 5;
}

.search-input {
  width: 100%;
  max-width: 400px;
  padding: 8px 12px;
  border: 1px solid #ccc;
  border-radius: 5px;
  font-size: 14px;
}

.map-area {
  height: 400px;
  width: 100%;
}
</style>

